import { useMemo } from "react";

const useColumns = () => {
    const columns = useMemo(
        () => [
            {
                accessorKey: 'word',
                header: "מילה",
            }
        ], []
    )

    return columns
}

export default useColumns